import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarRemove = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M5 3V1.667M11 3V1.667M6.165 6.5l3.668 3.668M9.834 6.5l-3.667 3.668m-1.834 3.499h7.334a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4.333a2 2 0 0 0-2 2v6.667a2 2 0 0 0 2 2"
	})
});
export default SvgCalendarRemove;
